module.exports = __webpack_public_path__ + "img/couples-038.075ac098.jpg";